/**
 * Full observation data table with CSV + PDF export.
 */

import { useDashboardContext } from '@/components/layout/DashboardShell';
import { FullDataTable } from '@/components/dashboard/FullDataTable';
import { ExportToolbar } from '@/components/dashboard/ExportToolbar';

export function ObservationsTablePage() {
  const { filtered } = useDashboardContext();

  return (
    <div className="mx-auto w-full max-w-7xl space-y-4 px-6 py-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="text-sm font-semibold text-muted-foreground uppercase tracking-wide">
          All Observations ({filtered.length})
        </h2>
        <ExportToolbar observations={filtered} />
      </div>
      <FullDataTable observations={filtered} />
    </div>
  );
}
